import React, { useEffect, useState } from "react";
import { FaAngleDoubleUp } from "react-icons/fa"; // You can replace this with your own SVG if needed
import themeLarge from "../ThemeLarge";

const ScrollButton = () => {
  const [atBottom, setAtBottom] = useState(false);
  const [visible, setVisible] = useState(true);
  let scrollTimeout = null;

  useEffect(() => {
    const handleScroll = () => {
      // Hide the button while scrolling
      setVisible(false);

      // Clear previous timeout
      clearTimeout(scrollTimeout);

      // Show it again after scrolling stops
      scrollTimeout = setTimeout(() => {
        setVisible(true);
      }, 500); // 200ms after scroll stops

      // Check if we're at the bottom
      const bottom =
        window.innerHeight + window.scrollY >= document.body.scrollHeight - 10;
      setAtBottom(bottom);
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
      clearTimeout(scrollTimeout);
    };
  }, []);

  const handleClick = () => {
    if (atBottom) {
      // Scroll to top
      window.scrollTo({ top: 0, behavior: "smooth" });
    } else {
      // Scroll down a little bit
      window.scrollBy({ top: window.innerHeight / 2, behavior: "smooth" });
    }
  };

  return (
    visible && (
      <div
        onClick={handleClick}
        style={{
          position: "fixed",
          bottom: "20px",
          right: "20px",
          backgroundColor: themeLarge.colors.bg,
          borderWidth: "1px",
          borderStyle: "solid",
          borderColor: themeLarge.colors.hover,
          padding: "10px",
          cursor: "pointer",
          transition: "opacity 0.5s ease, transform 0.5s ease",
          transform: atBottom ? "rotate(0deg)" : "rotate(180deg)",
          boxShadow: atBottom
            ? themeLarge.shadows.little
            : themeLarge.shadows.littleReverse,
          opacity: visible ? 1 : 0, // fade in/out
          pointerEvents: visible ? "auto" : "none",
          zIndex: 1000,
        }}
      >
        <FaAngleDoubleUp color="#5A189A" size={24} />
      </div>
    )
  );
};

export default ScrollButton;
